var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-items"},_vm._l((_vm.types),function(type,index){return _c('container-item',{key:index,attrs:{"type":type}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }